module.exports = __webpack_public_path__ + "img/nft.1ec110fb.svg";